"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.FlagSwallowtailSVG = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _Icon = require("../Icon");
var _excluded = ["children"];
var FlagSwallowtailSVG = function FlagSwallowtailSVG(_ref) {
  var children = _ref.children,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/_react.default.createElement("path", {
    stroke: "none",
    d: "M29.8 20.4L24.3 13l5.5-6.4a1 1 0 00.1-1A1 1 0 0029 5H6V4a1 1 0 00-2 0v5H3a1 1 0 000 2h1v5H3a1 1 0 000 2h1v10a1 1 0 002 0v-6h23a1 1 0 00.8-1.6zM8 18H6v-2h2a1 1 0 010 2zm0-7H6V9h2a1 1 0 010 2z"
  }));
};
exports.FlagSwallowtailSVG = FlagSwallowtailSVG;
FlagSwallowtailSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: _propTypes.default.node
} : {};
var _default = (0, _Icon.withIcon)(FlagSwallowtailSVG);
exports.default = _default;